import Button from "../components/Misc/Button";
import LeftRightContentText from "../components/LeftRightContentText";
import { useAppContext } from "../_context";
import LeaveFeedback from "../components/LeaveFeedback";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import ImageLeftFooter from "../components/Footer/ImageLeftFooter";
import CoachesStringersHero from "../components/Pages/CoachesStringersHero";
import InfoBallSection from "../components/Misc/InfoBallSection";
import People from "../components/Icons/people.svg";
import Card from "../components/Icons/card.svg";
import Venue from "../components/Icons/venue.svg";
import Graph from "../components/Icons/graph.svg";
import StyledBulletList from "../components/StyledBulletList";
import BlueBoxImageAndText from "../components/Misc/BlueBoxImageAndText";
import Head from "next/head";

const Stringers = () => {
  const [{ tx }] = useAppContext();

  const howItWorks = () => {
    return [
      tx["Get in touch and let us know you want to sign up."],
      tx["We’ll review your details."],
      tx[
        "If everything looks good, we’ll create a profile for you and off you go."
      ],
    ];
  };
  const infoBallItems = [
    {
      icon: People,
      label: tx["Accessible to tens of thousands of customers"],
    },
    {
      icon: Card,
      label: tx["No commission or monthly fee"],
    },
    {
      icon: Graph,
      label: tx["Find customers and boost your earnings"],
    },
    {
      icon: Venue,
      label: tx["Build a profile for your business"],
    },
  ];

  const bulletList = [
    tx["Reach an engaged community of active players in your area"],
    tx["Boost the demand for your lessons"],
    tx["Find new clients in minutes"],
    tx["Grow your business using your RacketPal profile"],
  ];

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Stringers"]}</title>
      </Head>
      <CoachesStringersHero as="stringers" />
      <LeftRightContentText title={tx["Your services are in demand"]}>
        <p>
          {
            tx[
              "When you have a thriving community like RacketPal, with thousands of active tennis, badminton and squash players, more than a few strings are gonna break. And we’d love you to be there to help fix them."
            ]
          }
        </p>
        <p className="mb-0">
          {
            tx[
              "Join RacketPal as a stringer and you can offer your professional racket stringing services to our players."
            ]
          }
        </p>
      </LeftRightContentText>
      <InfoBallSection
        items={infoBallItems}
        label={tx["Benefits of using RacketPal"]}
      />
      <BlueBoxImageAndText
        image="/img/stringers/features.jpg"
        className="section-padding-bottom">
        <h2>{tx["Why join RacketPal as a stringer?"]}</h2>
        <h4 className="text-grey-1 fw-normal">
          {
            tx[
              "The RacketPal community is growing by the second and it’s the perfect opportunity to grow your racket stringing business."
            ]
          }
        </h4>
        <StyledBulletList bulletList={bulletList} />
      </BlueBoxImageAndText>
      <HowItWorks items={howItWorks()}>
        <h2>{tx["How it works"]}</h2>
        <p className="text-grey-1">
          {
            tx[
              "Sign up now for free and be part of our team of professional racket stringers within minutes. Here’s how it works..."
            ]
          }
        </p>
      </HowItWorks>
      <LeaveFeedback />
      <ImageLeftFooter image="/img/footers/stringers-signup.jpg" light={true}>
        <h2>{tx["Sign up now for FREE"]}</h2>
        <p>
          {
            tx[
              "It’s completely free to join RacketPal as a professional racket stringer. Get in touch and let us know you want to sign up as a stringer and let’s get the ball rolling."
            ]
          }
        </p>
        <Button href="/contact?reason=stringers">{tx["Get started"]}</Button>
      </ImageLeftFooter>
    </>
  );
};

export default Stringers;
